module.exports = __webpack_public_path__ + "static/scissors-517f082bae6d2a4762432993a9b6699a.gif";